import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink, RouterModule, NavigationEnd } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { BASE_URL_PREMOCENTER_FRONT } from '../../app.constants';
import { PermissoesService } from 'app/services/permissoes/permissoes.service';
import { SidebarService } from 'app/services/sidebar/sidebar.service';
import { SelecionarIdiomaComponent } from '../selecionar-idioma/selecionar-idioma.component';
import { SideBarItem } from 'app/interfaces/SideBarNav';
import { filter } from 'rxjs';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    MatListModule,
    MatSidenavModule,
    MatTooltipModule,
    MatIconModule,
    RouterLink,
    RouterModule,
    SelecionarIdiomaComponent,
    TranslocoModule
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent implements OnInit {
  open = false;
  linguagemMenu = false;
  urlPremocenter = BASE_URL_PREMOCENTER_FRONT;
  token = localStorage.getItem('token');

  conteudoSideNav: SideBarItem[] = [];

  constructor(
    private permissaoService: PermissoesService,
    private sidebarService: SidebarService,
    private router: Router,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.open = false;
    this.sidebarService.setExpanded(false);

    this.inicializarSidebarNav();
    this.subscribeEventosRouter();
    this.subscribeSidebarExpansao();

    this.translocoService.langChanges$.subscribe(() => {
      this.inicializarSidebarNav();
    });
  }

  private subscribeEventosRouter(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.open = false;
        this.abrirOufecharMenu(false);
      });
  }

  private subscribeSidebarExpansao(): void {
    this.sidebarService.isExpanded$.subscribe(expanded => {
      this.open = expanded;
      this.abrirOufecharMenu(expanded);
    });
  }

  private inicializarSidebarNav(): void {
    const menuItems = this.getItemsMenuPrincipal();
    const cadastrosSubmenu = this.getCadastrosSubmenu();

    this.conteudoSideNav = [
      ...menuItems,
      {
        nome: 'COMPONENTS.SIDEBAR.sidebar_menu.registrations',
        icone: 'assets/icones-sideBar/cadastros.svg',
        permissao: true,
        open: false,
        submenu: cadastrosSubmenu,
        acao: () => this.acaoMenu(true)
      }
    ];
  }

  private getItemsMenuPrincipal(): SideBarItem[] {
    return [
      {
        nome: 'COMPONENTS.SIDEBAR.sidebar_menu.map',
        icone: 'assets/icones-sideBar/map.svg',
        link: '/premoplan',
        permissao: this.checarPermissao('acessar_mapa_premoplan')
      },
      {
        nome: 'COMPONENTS.SIDEBAR.sidebar_menu.dashboard',
        icone: 'assets/icones-sideBar/dashboard.svg',
        link: this.getDashboardLink(),
        permissao:
          this.checarPermissao('acessar_dashboard_tempo_real_premoplan') ||
          this.checarPermissao('acessar_dashboard_historico_premoplan')
      },
      {
        nome: 'COMPONENTS.SIDEBAR.sidebar_menu.goals',
        icone: 'assets/icones-sideBar/metas.svg',
        link: '/premoplan/metas',
        permissao: this.checarPermissao('acessar_metas_premoplan')
      },
      {
        nome: 'COMPONENTS.SIDEBAR.sidebar_menu.history',
        icone: 'assets/icones-sideBar/historico-apontamentos.svg',
        link: '/premoplan/apontamentos',
        permissao: this.checarPermissao('acessar_apontamentos_premoplan')
      },
      {
        nome: 'COMPONENTS.SIDEBAR.sidebar_menu.tractor_info',
        icone: 'assets/icones-sideBar/informacoes-trator.svg',
        link: '/premoplan/informacoes-trator',
        permissao: this.checarPermissao('acessar_informacoes_trator_premoplan')
      },
      {
        nome: 'COMPONENTS.SIDEBAR.sidebar_menu.agview_connect',
        icone: 'assets/icones-sideBar/agview-connect.svg',
        link: '/premoplan/agview-connect',
        permissao: this.checarPermissao('acessar_agviewconnect_premoplan')
      },
      {
        nome: 'COMPONENTS.SIDEBAR.sidebar_menu.chat',
        icone: 'assets/icones-sideBar/chat-coa.svg',
        link: '/premoplan/chat',
        permissao: this.checarPermissao('acessar_chat_premoplan')
      },
      {
        nome: 'COMPONENTS.SIDEBAR.sidebar_menu.kanban',
        icone: 'assets/icones-sideBar/kanban.svg',
        link: '/premoplan/kanban',
        permissao: this.checarPermissao('acessar_kanban_premoplan')
      }
    ];
  }

  private getCadastrosSubmenu(): SideBarItem[] {
    return [
      {
        nome: 'COMPONENTS.SIDEBAR.SUBMENU.shifts',
        icone: 'assets/icones-sideBar/turnos.svg',
        link: '/premoplan/turnos',
        permissao: this.checarPermissao('acessar_turnos_premoplan')
      },
      {
        nome: 'COMPONENTS.SIDEBAR.SUBMENU.equipments',
        icone: 'assets/icones-sideBar/equipamentos.svg',
        link: '/premoplan/equipamentos',
        permissao: this.checarPermissao('acessar_equipamentos_premoplan')
      },
      {
        nome: 'COMPONENTS.SIDEBAR.SUBMENU.workfronts',
        icone: 'assets/icones-sideBar/frentes.svg',
        link: '/premoplan/frentes',
        permissao: this.checarPermissao('acessar_frentes_premoplan')
      },
      {
        nome: 'COMPONENTS.SIDEBAR.SUBMENU.operations',
        icone: 'assets/icones-sideBar/operacoes.svg',
        link: '/premoplan/operacoes',
        permissao: this.checarPermissao('acessar_operacoes_premoplan')
      },
      {
        nome: 'COMPONENTS.SIDEBAR.SUBMENU.ideal_rates',
        icone: 'assets/icones-sideBar/taxa-ideal.svg',
        link: '/premoplan/taxas-ideais',
        permissao: this.checarPermissao('acessar_operacoes_premoplan')
      },
      {
        nome: 'COMPONENTS.SIDEBAR.SUBMENU.ideal_speed',
        icone: '',
        link: '/premoplan/velocidade-ideal',
        permissao: true
      },
      {
        nome: 'COMPONENTS.SIDEBAR.SUBMENU.inputs',
        icone: '',
        link: '/premoplan/insumos',
        permissao: this.checarPermissao('acessar_insumos_premoplan')
      }
    ];
  }

  private checarPermissao(permission: string): boolean {
    return this.permissaoService.usuarioTemPermissao(permission);
  }

  private getDashboardLink(): string {
    return this.checarPermissao('acessar_dashboard_tempo_real_premoplan')
      ? '/premoplan/dashboard/dashboard-tempo-real'
      : '/premoplan/dashboard/dashboard-historico';
  }

  acaoMenu(condition: boolean): void {
    this.open = condition;
    this.sidebarService.setExpanded(condition);
    this.abrirOufecharMenu(condition);

    if (!condition) {
      const ultimo = this.conteudoSideNav[this.conteudoSideNav.length - 1];
      if (ultimo?.submenu) {
        ultimo.open = false;
      }
    }
  }

  abrirOufecharMenu(option: boolean): void {
    const nav = document.getElementById('nav');
    nav?.classList.toggle('nav-aberta', option);
    nav?.classList.toggle('nav-fechada', !option);
  }

  retornarPremocenter(): void {
    localStorage.removeItem('cliente');
    localStorage.removeItem('token');
    localStorage.removeItem('permissoes');
    window.location.href = `${this.urlPremocenter}/redirect/${this.token}`;
  }

  abrirModal(): void {
    this.linguagemMenu = true;
  }

  fecharModal(): void {
    this.linguagemMenu = false;
  }
}
